enum ChallengeType {
	'PinPoint' = 'PinPoint',
	'PinPointLeaderboard' = 'PinPointLeaderboard',
	'FullRound' = 'FullRound',
	'LongestDrive' = 'LongestDrive',
}

export default ChallengeType;
